import React from 'react';
import { Card, Typography, Box, Stack, Tooltip } from '@mui/material';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'; // Assuming this icon is used, or replace with appropriate icon
import { SxProps, Theme } from '@mui/system';


interface SummaryCardProps {
  title: string;
  amount: string;
  entityName?: string;
  change?: string;
  changeColor?: string;
  comparisonText?: string; // NEW: To make "vs last month" dynamic
  credits?: string;
  changeType?: 'increase' | 'decrease';
    sx?: SxProps<Theme>; // <-- This line must be present

}

const SummaryCard: React.FC<SummaryCardProps> = ({ title, amount, entityName, change, changeColor, comparisonText, credits, changeType , sx}) => {
  const defaultChangeColor = changeType === 'increase' ? '#14AE5C' : changeType === 'decrease' ? '#E53935' : 'text.secondary';
  const iconColor = changeType === 'increase' ? '#14AE5C' : changeType === 'decrease' ? '#E53935' : 'inherit';

  return (
    <Card
      sx={{
        backgroundColor:  ' rgba(242, 247, 255, 1)', // Changed background to white as per previous image for the main card
        borderRadius: '12px',
        p: '14px',
        boxShadow: 'none', // Removed shadow as per previous discussion
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        // height: '100%',
        flex: 1,
        // minHeight: '100px',
        ...sx,
      }}
    >
      {entityName ? (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            <Typography variant="body2" color="#6B7280" sx={{ fontFamily: 'Inter', flexShrink: 0, mr: 5 }}>
                {title}
            </Typography>
            <Tooltip title={entityName || ''} placement="top">
                <Typography variant="h6" sx={{ fontWeight: 500, fontFamily: 'Inter', fontSize: '16px', color: 'rgba(51, 51, 51, 1)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'right', minWidth: 0 }}>
                    {entityName}
                </Typography>
            </Tooltip>
        </Box>
      ) : (
        <Typography variant="body2" color="#6B7280" sx={{ mb: 0, fontFamily: 'Inter' }}>
            {title}
        </Typography>
      )}
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 0, fontFamily: 'Inter', fontSize: '20px', lineHeight: '2em', color: 'rgba(51, 51, 51, 1)' }}>
        {amount}
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt:0 }}>
        {change && (
          <Box
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              backgroundColor: 'rgba(255, 255, 255, 1)', // Background color from the image
              borderRadius: '500px', // Rounded corners for the change indicator
              p: '1px 4px', // Padding
              fontSize: '12px', // Font size for the change text
              fontWeight: 400,
              color: changeColor || defaultChangeColor, // Use passed color or default based on type
              fontFamily: 'Inter',
              border:' 1px solid rgba(230, 230, 230, 1)',
            }}
          >
          {changeType === 'decrease' ? (
            <ArrowDownwardIcon sx={{ fontSize: '16px', mr: '4px', transform: 'rotate(45deg)', color: iconColor }} />
            ) : (
              <ArrowDownwardIcon sx={{ fontSize: '16px', mr: '4px',transform: 'rotate(120deg)', color: iconColor }} />
            )}
            <Box component="span" sx={{ color: changeColor || defaultChangeColor }}> 
              {change}
            </Box>
            <Box component="span" sx={{ color: 'rgba(102, 102, 102, 1)', ml: '4px' }}>
              &bull; {comparisonText || 'vs last month'}
            </Box>
          </Box>
        )}
        {credits && (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                <Typography
                    variant="body1" // Or a smaller variant like 'body2' or 'subtitle2' if preferred
                    sx={{
                        fontWeight: 500, // Slightly bolder for the amount
                        fontSize: '13px', // Adjust font size as needed
                        color: 'rgba(51, 51, 51, 1)', // Darker color for the amount
                        fontFamily: 'Inter',
                        lineHeight: '15px', // Adjust line height if needed
                    }}
                >
                    {credits}
                </Typography>
                <Typography
                    variant="caption"
                    sx={{
                        fontSize: '11px', // Adjust font size as needed
                        color: 'rgba(107, 114, 128, 1)', // Lighter color for "Credits included"
                        fontFamily: 'Inter',
                        lineHeight: '15px', // Adjust line height if needed
                    }}
                >
                    Credits included
                </Typography>
            </Box>
        )}
      </Box>
    </Card>
  );
};

export default SummaryCard;
